import { Reducer } from 'redux'

import { MarginAcceptResultState, ConsultaMargemTypes } from './types'

const INITIAL_STATE: MarginAcceptResultState = {
  loading: false,
  error: false,
  consultaMargemRealizada: false,
}

const reducer: Reducer<MarginAcceptResultState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ConsultaMargemTypes.CONSULTA_MARGEM_ACCEPT_REQUEST:
      return { ...state, loading: true, error: false }
    case ConsultaMargemTypes.CONSULTA_MARGEM_ACCEPT_SUCCESS:
      return { ...state, loading: false, error: false, consultaMargemRealizada: true }
    case ConsultaMargemTypes.CONSULTA_MARGEM_ACCEPT_ERROR:
      return { ...state, loading: false, error: true }
    case ConsultaMargemTypes.CONSULTA_MARGEM_RESULT_REQUEST:
      return { ...state, loading: true, error: false }
    case ConsultaMargemTypes.CONSULTA_MARGEM_RESULT_SUCCESS:
      return { ...state, loading: false, error: false, consultaMargemRealizada: true }
    case ConsultaMargemTypes.CONSULTA_MARGEM_RESULT_ERROR:
      return { ...state, loading: false, error: true }
    case ConsultaMargemTypes.CONSULTA_MARGEM_RESET:
      return INITIAL_STATE
    default:
      return state
  }
}

export * from './actions'
export * from './types'
export { default as postMarginAcceptSaga } from './sagas/postMarginAcceptSaga'
export { default as postMarginResultSaga } from './sagas/postMarginResultSaga'
export default reducer
